(function() {
  var DEBOUNCE_MS = 500;
  var previewTimer = null;
  var previewXHR = null;

  function csrfToken() {
    var m = document.querySelector('meta[name="csrf-token"]');
    return m ? m.getAttribute("content") : "";
  }

  function dollars(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  function rppIcon(form, name, extraClass) {
    var url = form && form.dataset ? form.dataset["icon" + name.charAt(0).toUpperCase() + name.slice(1)] : "";
    if (!url) return "";
    var cls = "rpp-icon-img" + (extraClass ? " " + extraClass : "");
    return '<img src="' + url + '" class="' + cls + '" alt="">';
  }


  function isAutofillOn(panel) {
    var field = panel.querySelector(".js-autofill-defaults");
    return !field || field.value !== "0";
  }

  function setAutofillOn(panel, on) {
    var field = panel.querySelector(".js-autofill-defaults");
    if (field) field.value = on ? "1" : "0";
  }

  function isRestockManual(panel) {
    return panel && panel.getAttribute("data-restock-manual") === "1";
  }

  function setRestockManual(panel, manual) {
    if (!panel) return;
    if (manual) panel.setAttribute("data-restock-manual", "1");
    else panel.removeAttribute("data-restock-manual");
  }

  function inventoryActionIcon(restock) {
    if (restock) {
      return '<span class="rpp-line-item__action-icon rpp-line-item__action-icon--restock" aria-hidden="true">&#8635;</span>';
    }
    return '<span class="rpp-line-item__action-icon rpp-line-item__action-icon--no-restock" aria-hidden="true">&#10007;</span>';
  }

  function restockTag(panel) {
    var restockCb = panel.querySelector('input[name*="[restock]"][type="checkbox"]');
    return (restockCb && restockCb.checked) ? "place on restock cart" : "no restock cart";
  }

  function noRestockReasons(form) {
    if (!form || !form.dataset.noRestockReasons) return [];
    try {
      return JSON.parse(form.dataset.noRestockReasons);
    } catch (e) {
      return [];
    }
  }

  function anyRestockChecked(form) {
    if (!form) return false;
    var boxes = form.querySelectorAll(".js-restock-cart-checkbox");
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].checked) return true;
    }
    return false;
  }

  function syncRestockCartDetails(form) {
    if (!form) return;
    var block = form.querySelector(".js-restock-cart-details");
    if (!block) return;
    block.style.display = anyRestockChecked(form) ? "" : "none";

    var nameInput = form.querySelector("#return_cart_name");
    var locInput = form.querySelector("#return_cart_location");
    if (!anyRestockChecked(form)) {
      if (nameInput) nameInput.value = "";
      if (locInput) locInput.value = "";
      return;
    }

    if (nameInput && !nameInput.value) {
      var recentName = document.getElementById("recently_used_cart_name");
      if (recentName && recentName.value) nameInput.value = recentName.value;
    }
    if (locInput && !locInput.value) {
      var recentLoc = document.getElementById("recently_used_cart_location");
      if (recentLoc && recentLoc.value) locInput.value = recentLoc.value;
    }
  }

  function updateLineMoneySummary(panel, action) {
    var sku = panel.getAttribute("data-sku") || "";
    var qtyInput = panel.querySelector('input[name*="[quantity]"]');
    var refundInput = panel.querySelector('input[name*="[refund_amount]"]');
    var taxInput = panel.querySelector('input[name*="[tax_refund]"]');
    var summaryEl = panel.querySelector(".js-return-line-summary");
    if (!summaryEl) return;

    var qty = parseInt(qtyInput ? qtyInput.value : "0", 10) || 0;
    var refCents = Math.round(parseFloat(refundInput ? refundInput.value : "0") * 100) || 0;
    var taxCents = Math.round(parseFloat(taxInput ? taxInput.value : "0") * 100) || 0;

    if (action === "cancel_item") {
      summaryEl.innerHTML = "<span>Cancelling " + qty + " x " + sku +
        ": " + dollars(refCents) + " + " + dollars(taxCents) + " tax</span>";
      return;
    }

    if (action !== "return_refund") return;

    summaryEl.innerHTML = "<span>Refunding " + qty + " x " + sku +
      ": " + dollars(refCents) + " + " + dollars(taxCents) + " tax · " + restockTag(panel) + "</span>";
  }

  function updateRefundSummary(panel) {
    var sel = panel.querySelector('select[name*="[requested_action]"]');
    var action = sel ? sel.value : "no_action";
    if (action !== "return_refund" && action !== "cancel_item") return;

    updateLineMoneySummary(panel, action);
  }

  function actionNeedsReasonRestock(action) {
    return action === "return_refund" || action === "exchange" || action === "replacement";
  }

  function syncReasonRestockVisibility(panel, action) {
    var block = panel.querySelector(".js-return-line-reason-fields");
    if (!block) return;
    block.style.display = actionNeedsReasonRestock(action) ? "" : "none";
  }
  // --- Instant client-side autofill when action changes ---

  function autofillLine(panel, action) {
    setRestockManual(panel, false);
    syncReplacementVisibility(panel, action);
    syncReasonRestockVisibility(panel, action);

    var qty = parseInt(panel.getAttribute("data-li-quantity"), 10) || 0;
    var perUnit = parseInt(panel.getAttribute("data-li-per-unit-cents"), 10) || 0;
    var taxPerUnit = parseInt(panel.getAttribute("data-li-tax-per-unit-cents"), 10) || 0;
    var sku = panel.getAttribute("data-sku") || "";

    var qtyInput = panel.querySelector('input[name*="[quantity]"]');
    var refundInput = panel.querySelector('input[name*="[refund_amount]"]');
    var taxInput = panel.querySelector('input[name*="[tax_refund]"]');
    var restockCb = panel.querySelector('input[name*="[restock]"][type="checkbox"]');
    var summaryEl = panel.querySelector(".js-return-line-summary");

    if (action === "return_refund" || action === "cancel_item") {
      setAutofillOn(panel, true);
      var refundCents = perUnit * qty;
      var taxCents = taxPerUnit * qty;
      var form = panel.closest("form");
      if (qtyInput) qtyInput.value = qty;
      if (refundInput) refundInput.value = (refundCents / 100).toFixed(2);
      if (taxInput) taxInput.value = (taxCents / 100).toFixed(2);
      if (restockCb) restockCb.checked = false;
      syncRestockCartDetails(form);
      updateLineMoneySummary(panel, action);
    } else if (action === "exchange" || action === "replacement") {
      setAutofillOn(panel, true);
      if (qtyInput) qtyInput.value = qty;
      if (refundInput) refundInput.value = "0.00";
      if (taxInput) taxInput.value = "0.00";
      if (restockCb) restockCb.checked = false;
      syncRestockCartDetails(panel.closest("form"));
      if (summaryEl) {
        summaryEl.innerHTML = '<span class="subheader">Replace / exchange: select a replacement SKU below.</span>';
      }
    } else {
      if (qtyInput) qtyInput.value = "0";
      if (refundInput) refundInput.value = "";
      if (taxInput) taxInput.value = "";
      if (restockCb) restockCb.checked = false;
      if (summaryEl) {
        summaryEl.innerHTML = '<span class="subheader">No action on this line.</span>';
      }
    }

    updateLocalConsequencePanel(panel.closest("form"));
  }

  // --- Local consequence panel (fast approximation before server confirms) ---

  function updateLocalConsequencePanel(form) {
    if (!form) return;
    var panels = form.querySelectorAll(".js-return-line-panel");
    var totalCents = 0;
    var lines = [];

    panels.forEach(function(panel) {
      var sel = panel.querySelector('select[name*="[requested_action]"]');
      var action = sel ? sel.value : "no_action";
      if (action === "no_action") return;

      var refundInput = panel.querySelector('input[name*="[refund_amount]"]');
      var taxInput = panel.querySelector('input[name*="[tax_refund]"]');
      var qtyInput = panel.querySelector('input[name*="[quantity]"]');
      var sku = panel.getAttribute("data-sku") || "";
      var refCents = Math.round(parseFloat(refundInput ? refundInput.value : "0") * 100) || 0;
      var taxCents = Math.round(parseFloat(taxInput ? taxInput.value : "0") * 100) || 0;
      var q = parseInt(qtyInput ? qtyInput.value : "0", 10) || 0;
      var restockCb = panel.querySelector('input[name*="[restock]"][type="checkbox"]');
      var restock = restockCb ? restockCb.checked : false;

      totalCents += refCents + taxCents;
      lines.push({
        sku: sku,
        action: action,
        qty: q,
        refCents: refCents,
        taxCents: taxCents,
        restock: restock,
        actionLabel: action === "return_refund" ? "Return for refund" :
          action === "cancel_item" ? "Cancel item" : action.replace(/_/g, " "),
        restockLabel: restock ? "Place on restock cart" : "Do not place on restock cart"
      });
    });

    var body = document.getElementById("consequence-panel-body");
    if (!body) return;

    var html = '<div class="rpp-card"><div class="rpp-card__icon rpp-card__icon--customer">' + rppIcon(form, "customer") + '</div>';
    html += '<div class="rpp-card__body"><div class="rpp-card__title">Customer</div><div class="rpp-split">';
    html += '<div class="rpp-split__col"><div class="rpp-split__label">Refund amount</div>';
    if (totalCents > 0) {
      html += '<div class="rpp-split__value rpp-split__value--amount">' + dollars(totalCents) + '</div>';
    } else {
      html += '<div class="rpp-split__value rpp-split__value--none">$0.00</div>';
      html += '<div class="rpp-split__sub">No refund in this plan</div>';
    }
    html += '</div></div></div></div>';

    if (lines.length > 0) {
      html += '<div class="rpp-card"><div class="rpp-card__icon rpp-card__icon--inventory">' + rppIcon(form, "inventory", "rpp-icon-img--invert") + '</div>';
      html += '<div class="rpp-card__body"><div class="rpp-card__title">Inventory</div><div class="rpp-split">';
      html += '<div class="rpp-split__col">';
      lines.forEach(function(l) {
        html += '<div class="rpp-line-item"><span class="rpp-line-item__check rpp-check">&#10003;</span>';
        html += '<div><span class="rpp-line-item__sku">' + l.sku + ' x' + l.qty + '</span>';
        html += '<div class="rpp-line-item__detail">' + l.actionLabel + '</div></div></div>';
      });
      html += '</div><div class="rpp-split__col">';
      lines.forEach(function(l) {
        html += '<div class="rpp-line-item">' + inventoryActionIcon(l.restock);
        html += '<div><span class="rpp-line-item__sku">Action</span>';
        html += '<div class="rpp-line-item__detail">' + l.restockLabel + '</div></div></div>';
      });
      html += '</div></div></div></div>';
    }

    html += '<div class="rpp-risk rpp-risk--review"><div class="rpp-risk__icon">' + rppIcon(form, "security", "rpp-icon-img--security") + '</div>';
    html += '<div class="rpp-risk__body"><div class="rpp-risk__title">Risk level <span class="rpp-risk__badge">Updating</span></div>';
    html += '<p class="rpp-risk__message">Confirming plan details…</p></div></div>';

    body.innerHTML = html;
  }

  // --- Replacement field toggling ---

  function syncReplacementVisibility(panel, action) {
    var rep = panel.querySelector(".js-return-line-replacement-fields");
    if (rep) {
      var show = action === "exchange" || action === "replacement";
      rep.style.display = show ? "" : "none";
    }
  }

  // --- Server preview (authoritative, replaces local approximation) ---

  function applyLineUpdate(panel, line) {
    if (!panel || !line) return;
    var summary = panel.querySelector(".js-return-line-summary");
    if (summary && line.summary_html) summary.innerHTML = line.summary_html;

    var q = panel.querySelector('input[name*="[quantity]"]');
    if (q && typeof line.quantity !== "undefined") q.value = line.quantity;

    var ra = panel.querySelector('input[name*="[refund_amount]"]');
    if (ra && line.refund_dollars != null) ra.value = line.refund_dollars;

    var ta = panel.querySelector('input[name*="[tax_refund]"]');
    if (ta && line.tax_dollars != null) ta.value = line.tax_dollars;

    var restock = panel.querySelector('input[name*="[restock]"][type="checkbox"]');
    if (restock && !isRestockManual(panel)) {
      restock.checked = !!line.restock;
    }

    syncReplacementVisibility(panel, line.requested_action || "");
    syncReasonRestockVisibility(panel, line.requested_action || "");
  }

  function setProcessDisabled(form, risk) {
    var btn = form.querySelector('button[type="submit"][data-commit="process"]');
    if (!btn) return;
    btn.disabled = risk === "blocked";
  }

  function wireCommitButtons(form) {
    var hidden = document.getElementById("return-case-commit-value");
    if (!hidden) return;

    form.addEventListener("submit", function(ev) {
      var submitter = ev.submitter;
      if (submitter && submitter.getAttribute("data-commit")) {
        hidden.value = submitter.getAttribute("data-commit");
      }
    });

    form.querySelectorAll("button[data-commit]").forEach(function(btn) {
      btn.addEventListener("click", function() {
        hidden.value = btn.getAttribute("data-commit") || "save";
      });
    });
  }

  function schedulePreview(form) {
    var url = form.getAttribute("data-preview-url");
    if (!url) return;

    if (previewTimer) clearTimeout(previewTimer);
    previewTimer = setTimeout(function() {
      previewTimer = null;
      runPreview(form, url);
    }, DEBOUNCE_MS);
  }

  function previewRequestBody(form) {
    // Edit forms include _method=patch; Rack would rewrite POST to PATCH, but preview is POST-only.
    return $(form).serializeArray()
      .filter(function(pair) { return pair.name !== "_method"; })
      .map(function(pair) {
        return encodeURIComponent(pair.name) + "=" + encodeURIComponent(pair.value);
      })
      .join("&");
  }

  function showPreviewError(form, message) {
    var body = document.getElementById("consequence-panel-body");
    if (!body) return;
    var err = document.createElement("div");
    err.className = "rpp-alert rpp-alert--warning js-preview-error";
    err.style.marginTop = "0.5rem";
    err.innerHTML =
      '<span class="rpp-alert__icon" aria-hidden="true">&#9888;</span>' +
      '<div>' + message + '</div>';
    var existing = body.querySelector(".js-preview-error");
    if (existing) existing.remove();
    body.appendChild(err);
  }

  function runPreview(form, url) {
    if (previewXHR) previewXHR.abort();
    previewXHR = $.ajax({
      url: url,
      type: "POST",
      data: previewRequestBody(form),
      dataType: "json",
      headers: { "X-CSRF-Token": csrfToken() },
      success: function(resp) {
        previewXHR = null;
        var wrap = document.getElementById("consequence-panel-body");
        if (wrap && resp.html) wrap.innerHTML = resp.html;
        setProcessDisabled(form, resp.risk);

        if (resp.lines && resp.lines.length) {
          resp.lines.forEach(function(line) {
            var panel = null;
            if (line.id) {
              panel = form.querySelector('.js-return-line-panel[data-return-line-id="' + line.id + '"]');
            }
            if (!panel && line.line_item_id) {
              panel = form.querySelector('.js-return-line-panel[data-line-item-id="' + line.line_item_id + '"]');
            }
            applyLineUpdate(panel, line);
          });
        }
      },
      error: function(xhr) {
        previewXHR = null;
        if (xhr && xhr.statusText === "abort") return;
        showPreviewError(form, "Could not refresh the preview. Try saving the draft or reloading the page.");
      }
    });
  }

  // --- Recalculate amounts when qty changes ---

  function recalcForQty(panel) {
    var sel = panel.querySelector('select[name*="[requested_action]"]');
    var action = sel ? sel.value : "no_action";
    if (action !== "return_refund") return;
    if (!isAutofillOn(panel)) {
      updateRefundSummary(panel);
      updateLocalConsequencePanel(panel.closest("form"));
      return;
    }

    var perUnit = parseInt(panel.getAttribute("data-li-per-unit-cents"), 10) || 0;
    var taxPerUnit = parseInt(panel.getAttribute("data-li-tax-per-unit-cents"), 10) || 0;
    var sku = panel.getAttribute("data-sku") || "";
    var maxQty = parseInt(panel.getAttribute("data-li-quantity"), 10) || 0;

    var qtyInput = panel.querySelector('input[name*="[quantity]"]');
    var qty = parseInt(qtyInput ? qtyInput.value : "0", 10) || 0;
    if (qty > maxQty) { qty = maxQty; if (qtyInput) qtyInput.value = qty; }
    if (qty < 0) { qty = 0; if (qtyInput) qtyInput.value = 0; }

    var refundCents = perUnit * qty;
    var taxCents = taxPerUnit * qty;

    var refundInput = panel.querySelector('input[name*="[refund_amount]"]');
    var taxInput = panel.querySelector('input[name*="[tax_refund]"]');
    var summaryEl = panel.querySelector(".js-return-line-summary");

    if (refundInput) refundInput.value = (refundCents / 100).toFixed(2);
    if (taxInput) taxInput.value = (taxCents / 100).toFixed(2);
    updateRefundSummary(panel);
    updateLocalConsequencePanel(panel.closest("form"));
  }

  // --- Return reason / restock cart sync (matches orders/return_items) ---

  function syncReasonRestock(select) {
    var form = select.closest("form");
    var panel = select.closest(".js-return-line-panel") || select.closest("details");
    if (!panel) return;

    var restock = panel.querySelector(".js-restock-checkbox");
    var val = select.value;

    if (restock && !isRestockManual(panel) && val && noRestockReasons(form).indexOf(val) !== -1) {
      restock.checked = false;
    }
    syncRestockCartDetails(form);
  }

  // --- Form wiring ---

  function wireForm(form) {
    if (!form) return;

    wireCommitButtons(form);

    form.addEventListener("change", function(ev) {
      var t = ev.target;
      if (!t || !t.name) return;
      if (t.name.indexOf("requested_action") !== -1) {
        var panel = t.closest(".js-return-line-panel");
        if (panel) autofillLine(panel, t.value);
      }
      if (t.classList.contains("js-return-reason-select")) {
        syncReasonRestock(t);
        var reasonPanel = t.closest(".js-return-line-panel");
        if (reasonPanel) {
          updateRefundSummary(reasonPanel);
          updateLocalConsequencePanel(form);
        }
      }
      if (t.classList.contains("js-restock-checkbox")) {
        var panel = t.closest(".js-return-line-panel");
        if (panel) {
          setRestockManual(panel, true);
          updateRefundSummary(panel);
        }
        syncRestockCartDetails(form);
        updateLocalConsequencePanel(form);
      }
      schedulePreview(form);
    });

    form.addEventListener("input", function(ev) {
      var t = ev.target;
      if (!t || !t.name) return;
      if (t.name.indexOf("return_case[") !== 0) return;
      var panel = t.closest(".js-return-line-panel");
      if (t.classList.contains("js-refund-amount-input") || t.classList.contains("js-tax-refund-input")) {
        if (panel) setAutofillOn(panel, false);
      }
      if (t.name.indexOf("[quantity]") !== -1) {
        if (panel) recalcForQty(panel);
      }
      schedulePreview(form);
    });

    form.querySelectorAll(".js-return-line-panel").forEach(function(panel) {
      var sel = panel.querySelector('select[name*="[requested_action]"]');
      if (sel) {
        syncReplacementVisibility(panel, sel.value);
        syncReasonRestockVisibility(panel, sel.value);
      }
    });

    syncRestockCartDetails(form);

    form.addEventListener("click", function(ev) {
      var chip = ev.target.closest(".ship-chip, .goodwill-chip");
      if (chip) {
        var cents = parseInt(chip.getAttribute("data-cents"), 10);
        var row = chip.closest(".panel.callout, .js-adjustment-row");
        if (!row) return;
        var inp = row.querySelector("input[name*='[amount]']");
        if (inp) {
          inp.value = (cents / 100).toFixed(2);
          schedulePreview(form);
        }
        return;
      }

      var removeBtn = ev.target.closest(".js-remove-adjustment");
      if (removeBtn) {
        var row = removeBtn.closest(".js-adjustment-row");
        if (!row) return;
        var flag = row.querySelector(".js-destroy-flag");
        if (flag) flag.value = "1";
        row.style.display = "none";
        schedulePreview(form);
        return;
      }

      var addBtn = ev.target.closest(".js-add-adjustment");
      if (addBtn) {
        addAdjustmentRow(form, addBtn);
        return;
      }

      if (ev.target.id === "js-refund-all-btn") {
        refundAllItems(form);
        return;
      }

      if (ev.target.id === "js-cancel-all-btn") {
        cancelAllItems(form);
        return;
      }
    });
  }

  function cancelAllItems(form) {
    form.querySelectorAll(".js-return-line-panel").forEach(function(panel) {
      if (panel.getAttribute("data-can-cancel") !== "1") return;
      var sel = panel.querySelector('select[name*="[requested_action]"]');
      if (!sel) return;
      var hasCancel = Array.prototype.some.call(sel.options, function(opt) {
        return opt.value === "cancel_item";
      });
      if (!hasCancel) return;
      if (sel.value !== "cancel_item") {
        sel.value = "cancel_item";
        autofillLine(panel, "cancel_item");
      }
    });
    schedulePreview(form);
  }

  function refundAllItems(form) {
    form.querySelectorAll(".js-return-line-panel").forEach(function(panel) {
      var sel = panel.querySelector('select[name*="[requested_action]"]');
      if (sel && sel.value !== "return_refund") {
        sel.value = "return_refund";
        autofillLine(panel, "return_refund");
      }
    });
    schedulePreview(form);
  }

  var adjCounter = Date.now();

  function addAdjustmentRow(form, btn) {
    var type = btn.getAttribute("data-type");
    var label = btn.getAttribute("data-label");
    var defaultCents = parseInt(btn.getAttribute("data-default-cents"), 10) || 0;
    var defaultAmount = defaultCents > 0 ? (defaultCents / 100).toFixed(2) : "";

    adjCounter++;
    var idx = adjCounter;
    var prefix = "return_case[customer_adjustments_attributes][" + idx + "]";

    var chips = "";
    if (type === "shipping_refund" && defaultCents > 0) {
      chips = '<p style="margin-bottom:0.25rem;"><small>Full shipping on order: $' + (defaultCents / 100).toFixed(2) + '.</small></p>' +
              '<button type="button" class="button tiny secondary ship-chip" data-cents="' + defaultCents + '">Full shipping</button>';
    }
    if (type === "goodwill_refund") {
      chips = '<button type="button" class="button tiny secondary goodwill-chip" data-cents="500">$5</button> ' +
              '<button type="button" class="button tiny secondary goodwill-chip" data-cents="1000">$10</button> ' +
              '<button type="button" class="button tiny secondary goodwill-chip" data-cents="1500">$15</button>';
    }

    var isShipping = type === "shipping_refund";
    var reasonLabel = isShipping ? "Reason (optional)" : "Reason";
    var reasonPlaceholder = isShipping ? "Optional note" : "Required for audit";

    var html = '<div class="panel callout js-adjustment-row" style="padding: 0.75rem; margin-bottom: 0.75rem; position: relative;">' +
      '<input type="hidden" name="' + prefix + '[adjustment_type]" value="' + type + '">' +
      '<input type="hidden" name="' + prefix + '[_destroy]" value="0" class="js-destroy-flag">' +
      '<button type="button" class="js-remove-adjustment" title="Remove" style="position: absolute; top: 0.5rem; right: 0.5rem; background: none; border: none; color: #c00; font-size: 1.25rem; cursor: pointer; line-height: 1; padding: 0 0.25rem;">✕</button>' +
      '<strong>' + label + '</strong>' +
      '<div class="row" style="margin-top: 0.5rem;">' +
        '<div class="small-12 medium-4 columns">' +
          '<label>Amount ($)<input type="text" name="' + prefix + '[amount]" value="' + defaultAmount + '"></label>' +
        '</div>' +
        '<div class="small-12 medium-8 columns">' +
          '<label>' + reasonLabel + '<input type="text" name="' + prefix + '[reason]" placeholder="' + reasonPlaceholder + '"></label>' +
        '</div>' +
      '</div>' +
      chips +
    '</div>';

    var container = form.querySelector("#js-adjustments-container");
    if (container) {
      container.insertAdjacentHTML("beforeend", html);
    }
    schedulePreview(form);
  }

  // --- Variant picker for exchange/replacement ---

  var siblingCache = {};

  function loadSiblings(form, picker) {
    var url = form.getAttribute("data-siblings-url");
    if (!url) return;

    var sku = picker.getAttribute("data-original-sku");
    if (!sku) return;

    if (siblingCache[sku]) {
      populatePicker(picker, siblingCache[sku]);
      return;
    }

    picker.disabled = true;
    $.ajax({
      url: url,
      type: "GET",
      data: { sku: sku },
      dataType: "json",
      headers: { "X-CSRF-Token": csrfToken() },
      success: function(resp) {
        picker.disabled = false;
        if (resp.siblings && resp.siblings.length) {
          siblingCache[sku] = resp.siblings;
          populatePicker(picker, resp.siblings);
        }
      },
      error: function() { picker.disabled = false; }
    });
  }

  function populatePicker(picker, siblings) {
    var current = picker.value;
    picker.innerHTML = '<option value="">Select from same product</option>' +
                       '<option value="__custom">Enter custom SKU…</option>';
    siblings.forEach(function(s) {
      var sel = (s.item_code === current) ? " selected" : "";
      var tag = s.current ? " (original)" : "";
      picker.innerHTML += '<option value="' + s.item_code + '"' + sel + '>' +
        s.label + ' - ' + s.price_display + ' ' + s.diff_display + tag + '</option>';
    });
  }

  function handleVariantPick(form, picker) {
    var panel = picker.closest(".js-return-line-panel");
    if (!panel) return;

    var val = picker.value;
    var customRow = panel.querySelector(".js-custom-sku-row");
    var skuInput = panel.querySelector(".js-replacement-sku-input");
    var priceInfo = panel.querySelector(".js-variant-price-info");

    if (val === "__custom") {
      if (customRow) customRow.style.display = "";
      if (skuInput) skuInput.value = "";
      if (priceInfo) priceInfo.innerHTML = "";
      return;
    }

    if (customRow) customRow.style.display = "none";

    if (!val) {
      if (skuInput) skuInput.value = "";
      if (priceInfo) priceInfo.innerHTML = "";
      return;
    }

    if (skuInput) skuInput.value = val;

    var sku = picker.getAttribute("data-original-sku");
    var siblings = siblingCache[sku] || [];
    var match = null;
    for (var i = 0; i < siblings.length; i++) {
      if (siblings[i].item_code === val) { match = siblings[i]; break; }
    }

    if (priceInfo && match) {
      var diffHtml = "";
      if (match.diff_cents > 0) {
        diffHtml = '<div style="margin-top: 0.35rem; padding: 0.4rem 0.6rem; background: #fff3f3; border: 1px solid #f5c6cb; border-radius: 3px;">' +
          '<strong style="color: #c00;">Customer owes ' + match.diff_display + ' more</strong>' +
          '<br><small style="color: #666;">Cannot auto-charge. Send a payment link or create a separate invoice for the difference.</small>' +
          '</div>';
      } else if (match.diff_cents < 0) {
        diffHtml = '<div style="margin-top: 0.35rem; padding: 0.4rem 0.6rem; background: #f0fff0; border: 1px solid #c3e6cb; border-radius: 3px;">' +
          '<strong style="color: #080;">Refund ' + match.diff_display.replace("-", "") + ' to customer</strong>' +
          '<br><small style="color: #666;">Price difference will be included in the refund total automatically.</small>' +
          '</div>';
      } else {
        diffHtml = '<span style="color: #555;">Same price, even exchange. No charge or refund needed.</span>';
      }
      priceInfo.innerHTML = '<span>' + match.price_display + '</span> ' + diffHtml;
    }

    schedulePreview(form);
  }

  function verifyCustomSku(form, input) {
    var sku = input.value.trim();
    if (!sku) return;

    var panel = input.closest(".js-return-line-panel");
    if (!panel) return;

    var resultEl = panel.querySelector(".js-custom-sku-result");
    var hiddenVariantId = panel.querySelector(".js-replacement-variant-id");
    var originalSku = input.getAttribute("data-original-sku") || "";

    if (resultEl) resultEl.innerHTML = '<span style="color:#888;">Checking…</span>';

    var url = form.getAttribute("data-siblings-url");
    if (!url) return;

    $.ajax({
      url: url,
      type: "GET",
      data: { sku: sku },
      dataType: "json",
      headers: { "X-CSRF-Token": csrfToken() },
      success: function(resp) {
        if (!resp.siblings || resp.siblings.length === 0) {
          if (resultEl) resultEl.innerHTML = '<span style="color:#c00;">SKU not found</span>';
          if (hiddenVariantId) hiddenVariantId.value = "";
          return;
        }

        var match = null;
        for (var i = 0; i < resp.siblings.length; i++) {
          if (resp.siblings[i].item_code === sku) { match = resp.siblings[i]; break; }
        }

        if (!match && resp.siblings.length > 0) {
          match = resp.siblings[0];
          if (resultEl) resultEl.innerHTML = '<span style="color:#c00;">SKU "' + sku + '" not found in product. Did you mean one of these?</span>';
          return;
        }

        if (match) {
          var originalMatch = null;
          for (var j = 0; j < resp.siblings.length; j++) {
            if (resp.siblings[j].item_code === originalSku) { originalMatch = resp.siblings[j]; break; }
          }

          var diffHtml = "";
          if (originalMatch) {
            var diffCents = match.price_cents - originalMatch.price_cents;
            if (diffCents > 0) {
              diffHtml = '<div style="margin-top:0.25rem;padding:0.3rem 0.5rem;background:#fff3f3;border:1px solid #f5c6cb;border-radius:3px;">' +
                '<strong style="color:#c00;">+' + dollars(diffCents) + ', customer owes more</strong>' +
                '<br><small style="color:#666;">Send payment link separately.</small></div>';
            } else if (diffCents < 0) {
              diffHtml = '<div style="margin-top:0.25rem;padding:0.3rem 0.5rem;background:#f0fff0;border:1px solid #c3e6cb;border-radius:3px;">' +
                '<strong style="color:#080;">−' + dollars(Math.abs(diffCents)) + ' refund to customer</strong></div>';
            } else {
              diffHtml = '<span style="color:#555;">Same price, no charge.</span>';
            }
          }

          if (resultEl) {
            resultEl.innerHTML = '<span style="color:#2a7d2a;">✓ ' + match.label + ' - ' + match.price_display + '</span>' + diffHtml;
          }
          if (hiddenVariantId) hiddenVariantId.value = "";
        }

        schedulePreview(form);
      },
      error: function() {
        if (resultEl) resultEl.innerHTML = '<span style="color:#888;">Could not verify SKU</span>';
      }
    });
  }

  function wireVariantPickers(form) {
    form.addEventListener("focus", function(ev) {
      var picker = ev.target.closest(".js-variant-picker");
      if (!picker) return;
      if (picker.options.length <= 3) {
        loadSiblings(form, picker);
      }
    }, true);

    form.addEventListener("change", function(ev) {
      var picker = ev.target.closest(".js-variant-picker");
      if (!picker) return;
      handleVariantPick(form, picker);
    });

    form.addEventListener("blur", function(ev) {
      if (!ev.target.classList.contains("js-custom-sku-verify")) return;
      verifyCustomSku(form, ev.target);
    }, true);

    form.addEventListener("keydown", function(ev) {
      if (!ev.target.classList.contains("js-custom-sku-verify")) return;
      if (ev.key === "Enter") {
        ev.preventDefault();
        verifyCustomSku(form, ev.target);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll("form.return-case-quick-form").forEach(function(form) {
      wireForm(form);
      wireVariantPickers(form);
    });
  });
})();
